import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function TaskAdvancement({ progress, color, isCompleted }: Props) {
  return (
    <div
      className={classNames(styles.taskAdvancement, {
        [styles.completed]: isCompleted,
      })}
    >
      <div
        className={styles.bar}
        style={{ right: `calc(100% - ${progress}%)`, backgroundColor: color }}
      />
    </div>
  );
}

export { TaskAdvancement };
